import React from 'react';
import HomeSubSection from '../HomeSubSection/HomeSubSection';
import PNBenefits from '../Benefits/PNBenefits';
import CBN from "../../../images/concept-using-cloud-online-system-is-convenient-economical-energy-saving-low-cost.jpg";


export default function AAMCNetworkSection1() {
  return (
        <div className=" pb-0" id="Technology">
          <h2 className="container-title text-center">AAMC Overview</h2>
          <div className=" ">
            <HomeSubSection
              fontBold="true"
              className="rowReverseAbout align-items-center"
              listItems={<PNBenefits />}
              description="AAMC is a technology cloud platform for Agri-MSMEs to enable the digital transformation with the following benefits"
              descriptionTitle="Agri Asset Management Cloud"
              src={CBN}
              grid="true"
            />
          </div>
        </div> 
  )
}
